// Local types for the central Email workspace. The generated client types
// these endpoints loosely, so the shapes we rely on live here.
export type MessageStatus = "draft" | "approved" | "sending" | "paused" | "cancelled" | "completed" | "needs_attention";

export type EmailMessage = {
  id: number; source: string; essential: boolean; subject: string; body_text: string;
  request: string | null; status: MessageStatus; version: number;
  created_by: string | null; approved_by: string | null; approved_at: string | null;
  scheduled_at: string | null; created_at: string; updated_at: string;
  total: number; sent: number; excluded: number; failed: number;
};
export type EmailSettings = { paused: boolean; min_hours: number; daily_limit: number };
export type EmailSource = { id: string; label: string; essential: boolean };
export type EmailCohort = { id: number; name: string };
export type EmailStats = { sent: number; delivered: number; bounced: number; complained: number; opened: number; pending: number; unknown: number };
export type Proposal = { subject: string; bodyText: string; to: string[]; cohortId?: number; request: string };
export type ChatItem = { id: number | string; role: string; content: string; proposal: Proposal | null; created_at: string };
export type Connection = { configured: boolean; status?: "configured" | "not_configured" | "unavailable"; message?: string; fromEmail: string | null; webhookConfigured: boolean };
export type Workspace = {
  messages: EmailMessage[]; settings: EmailSettings; sources: EmailSource[]; cohorts: EmailCohort[];
  stats: EmailStats; chat: ChatItem[]; connection: Connection;
};
export type Recipient = { id: number; email: string; name: string | null; status: string; reason: string | null; provider_id: string | null; event: string | null; eligibility: string | null };
export type MessageEvent = { action: string; actor: string | null; created_at: string; detail: unknown };
export type MessageDetail = {
  message: EmailMessage & { payload?: { html?: string; text?: string; from?: string } | null };
  recipients: Recipient[]; events: MessageEvent[];
};
export type Person = { email: string; name: string | null; blocked: boolean; reason: string | null };
export type PersonHistory = {
  email: string; eligibility: string | null; preference: { blocked?: boolean; reason?: string | null; updated_at?: string } | null;
  history: { id: number | string; subject: string; source: string; status: string; at: string; body_text: string | null; event: string | null }[];
  replies: { id: number | string; subject: string; body_text: string | null; received_at: string }[];
  events: MessageEvent[];
};
export type DraftInput = { subject: string; bodyText: string; to: string[]; cohortId?: number; request?: string };

const ROOT = `${import.meta.env.BASE_URL}api/admin/email`;

export async function emailApi<T>(path: string, init?: RequestInit): Promise<T> {
  const res = await fetch(`${ROOT}${path}`, {
    ...init,
    credentials: "include",
    headers: { "Content-Type": "application/json", "x-admin-token": localStorage.getItem("admin_token") || "", ...(init?.headers || {}) },
  });
  if (!res.ok) {
    const body = await res.json().catch(() => null);
    const msg = body?.error?.message || body?.message || (typeof body?.error === "string" ? body.error : null);
    throw new Error(msg || `Request failed (${res.status})`);
  }
  return res.json();
}

export const isAbort = (e: unknown) => e instanceof DOMException && e.name === "AbortError";
